import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import styles from '@components/ProductCardNew/ProductCardDescription/PriceArea/PriceArea.styles';
import IsShopMiddleware from '@utils/IsShopMiddleware';
import { IGpsrObject } from '@features/categories/typescript';
type PropsType = {
  price: string;
  priceUnit: string | undefined;
  promoPrice: string;
  omnibusPrice: string;
  showFrom: boolean;
  gpsr?: IGpsrObject | undefined;
};
const PriceArea = ({
  price,
  priceUnit,
  promoPrice,
  omnibusPrice,
  showFrom,
  gpsr = undefined
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const renderPriceUnit = (): JSX.Element | null => (price || promoPrice) && priceUnit && priceUnit === 'M2' ? <>
        /m<sup>2</sup>
      </> : null;
  const renderGpsr = (): JSX.Element | null => {
    if (!gpsr?.energyClassCode || !gpsr.energyClassIcon) {
      return null;
    }
    return <div sx={styles.gpsr}>
        <Image src={gpsr?.energyClassIcon} alt={gpsr?.energyClassCode} width={43} height={24} />
      </div>;
  };
  return <IsShopMiddleware>
      <div sx={styles.priceArea}>
        <div sx={styles.priceRow}>
          <span sx={styles.productCardInfoPrice(!!promoPrice)}>
            {showFrom && <>
                <span>{t('product.productCostFrom')}</span> {` `}
              </>}
            {promoPrice ? <>
                <span>
                  {' '}
                  {promoPrice}
                  {renderPriceUnit()}
                  {renderGpsr()}
                </span>
                <small>
                  {price}
                  {renderPriceUnit()}
                </small>
              </> : <>
                <span>
                  {' '}
                  {price}
                  {renderPriceUnit()}
                  {renderGpsr()}
                </span>
              </>}
          </span>

          <div sx={styles.omnibus}>
            {omnibusPrice && promoPrice && <p className="omnibus">
                {`${t('omnibusText')} ${omnibusPrice}`}
                {renderPriceUnit()}
              </p>}
          </div>
        </div>
      </div>
    </IsShopMiddleware>;
};
export default PriceArea;